export enum Brand {
  DNERO = "DNERO",
  BURGER_FUEL = "BURGER_FUEL",
  SHAKE_OUT = "SHAKE_OUT",
}
